import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const getContactDetailState = (state: AppState) => state.contactsAndOrganizations.contacts.contactDetail;

export const contactOverviewSelector = createSelector(getContactDetailState, state => state.overview);
export const contactPermissionsSelector = createSelector(getContactDetailState, state => state.permissions);

// Add other valid states here
export const contactDetailIsValidSelector = createSelector(
    getContactDetailState,
    state => state.overview.isValid && state.permissions.isValid
);

export const contactIsLockedSelector = createSelector(getContactDetailState, state => state.global.isLocked);
export const contactOrganizationsSelector = createSelector(getContactDetailState, state => state.global.organizations);
export const contactMainOrganizationSelector = createSelector(getContactDetailState, state => {
    const mainAccount = state.overview.contact?.mainAccount;
    const organizations = state.global.organizations;

    return organizations.find(organization => organization?.id === mainAccount?.id);
});

export const contactConditionsErrorSelector = createSelector(
    getContactDetailState,
    state => state.global.hasContactAssignedError
);

export const contactConditionsErrorContextSelector = createSelector(
    getContactDetailState,
    state => state.global.hasContactAssignedErrorContext
);

export const errorTypeSelector = createSelector(getContactDetailState, state => state.global.errorType);
